import FocusTwinsChild from './FocusTwinsChild';
import FocusTwinsParent from './FocusTwinsParent';

export default {
  Parent: FocusTwinsParent as typeof FocusTwinsParent,
  Child: FocusTwinsChild as typeof FocusTwinsChild,
};
